import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=56c83820&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c83820')) {
      api.createRecord('56c83820', component.options)
    } else {
      api.reload('56c83820', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=56c83820&", function () {
      api.rerender('56c83820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSZt4Y2Pc75N/JS/comp/DateRangeExt.vue"
export default component.exports